export const dailyLimitReachedApiErrors = 'DAILY_LIMIT_REACHED'
export const monthlyLimitReachedApiErrors = 'MONTHLY_LIMIT_REACHED'



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/caretakerServiceResponse/caretakerServiceResponse.model.ts